<template>
  <v-container>
    <v-textarea
      label="Наукоемкость"
      v-model="knowledgeIntensity"
      rows="1"
      auto-grow
    />
    <v-textarea
      label="Экспертная оценка в общем виде"
      v-model="chapterOneExpertise"
      rows="1"
      auto-grow
    />

    <v-text-field
      label="Оценка (баллы)"
      v-model="chapterOneScore"
      outlined
      readonly
      filled
    />
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";

export default {
  name: "TheChapterOneScore",
  components: {},
  data: () => ({}),
  props: {},
  computed: {
    ...mapGetters({ card: GETTERS.CARD_DATA }),

    knowledgeIntensity: {
      get() {
        return this.card.knowledgeIntensity;
      },
      set(value) {
        this.modify({ knowledgeIntensity: value });
      },
    },
    chapterOneExpertise: {
      get() {
        return this.card.chapterOneExpertise;
      },
      set(value) {
        this.modify({ chapterOneExpertise: value });
      },
    },

    chapterOneScore() {
      let value = 0;
      const priority = { "01": 10, "015": 7, "02": 5, "03": 2 };
      const personnel = { "02": 10, "03": 5 };
      const specifications = { "01": 10, "02": 5, "03": 3 };
      const consumables = { "01": 10, "02": 5 };

      const rewards = { 1: 2, 2: 4, 3: 10 };

      if (priority[this.card.priority])
        value = value + priority[this.card.priority];
      if (personnel[this.card.personnel])
        value = value + personnel[this.card.personnel];
      if (specifications[this.card.specifications])
        value = value + specifications[this.card.specifications];
      if (consumables[this.card.consumables])
        value = value + consumables[this.card.consumables];
      if (rewards[this.card.rewards])
        value = value + rewards[this.card.rewards];

      if (this.card.chapterOneScore !== value) {
        this.modify({ chapterOneScore: value });
      }
      return value;
    },
  },
  methods: {
    ...mapMutations({
      modify: MUTATIONS.MODIFY_CARD_DATA,
    }),
  },
};
</script>
